import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.BulkCreateVersionsModal.title',
    defaultMessage: 'Create versions',
  },
})
